import i18n from "../i18n/i18n";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateCheckoutInput(email) {
  if (!email?.trim()) {
    return i18n.t("errors.pleaseEnterEmail", "Please enter your email address.");
  }
  if (!emailRegex.test(email)) {
    return i18n.t("errors.pleaseEnterValidEmail", "Please enter a valid email address.");
  }
  return null;
}
